import type {AxiosInstance} from 'axios';
import {ENDPOINTS} from 'general/constants';

export const getCartItemsCount = async (instance: AxiosInstance): Promise<number> => {
    try {
        const {data} = await instance.get<{
            count: number;
        }>(ENDPOINTS.GET_QUOTE);
        return data.count || 0;
    } catch (error) {
        console.error('Failed to fetch cart data from Popup:', error);
        return 0;
    }
};
